import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import $api from 'http/index'

import styles from './DistanceLearningPage.module.scss'

const fmtDate = (iso) => {
  if (!iso) return '—'
  try {
    return new Date(iso).toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return '—'
  }
}

const DistanceLearningPage = () => {
  const { t } = useTranslation('common')

  const navigate = useNavigate()
  const [upcoming, setUpcoming] = useState([])
  const [error, setError] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        const res = await $api.get('/distance/classrooms/upcoming/')
        setUpcoming(res.data?.results || res.data || [])
      } catch {
        setError(true)
        setUpcoming([])
      }
    }
    load()
  }, [])

  return (
    <div className={styles.page}>
      <div className={`unv-card ${styles.header}`}>
        <h1 className={styles.title}>{t('menu.distance')}</h1>
        <div className={styles.subtitle}>{t('distance.subtitle_page')}</div>
      </div>

      <div className={styles.grid}>
        <div className={`unv-card ${styles.card}`}>
          <div className={styles.cardTitle}>{t('distance.card_lectures')}</div>
          <div className={styles.cardDesc}>
            {t('distance.card_lectures_desc')}
          </div>
          <button className="unv-btn" onClick={() => navigate('/distance/lectures/')}>
            Перейти
          </button>
        </div>

        <div className={`unv-card ${styles.card}`}>
          <div className={styles.cardTitle}>{t('distance.card_virtual')}</div>
          <div className={styles.cardDesc}>
            {t('distance.card_virtual_desc')}
          </div>
          {error ? (
            <div className="unv-empty">{t('schedule.section_in_dev')}</div>
          ) : upcoming.length === 0 ? (
            <div className="unv-empty">{t('distance.no_upcoming')}</div>
          ) : (
            <ul className={styles.upcomingList}>
              {upcoming.map((u) => (
                <li key={u.id}>
                  <button
                    className="unv-btn unv-btn--ghost"
                    onClick={() => navigate('/distance/virtual/')}
                  >
                    {u.title || u.subject_name || 'Занятие'} — {fmtDate(u.scheduled_at || u.start_at)}
                  </button>
                </li>
              ))}
            </ul>
          )}
          <button
            className="unv-btn"
            style={{ marginTop: 8 }}
            onClick={() => navigate('/distance/virtual/')}
          >
            Все виртуальные классы
          </button>
        </div>
      </div>
    </div>
  )
}

export default DistanceLearningPage
